import { listaSituacao } from './../shared/listas-parametros';
import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { Http } from '@angular/http';
import CustomStore from 'devextreme/data/custom_store';
import { NTECH_API } from './../app.api';
import { GridConfig, adicionaIconesGrid, calculaAlturaGrid } from './../app.config';
import { DxDataGridComponent } from 'devextreme-angular';

@Component({
  selector: 'ntc-promocao',
  templateUrl: './promocao.component.html',
  styleUrls: ['./promocao.component.css']
})
export class PromocaoComponent implements OnInit {
  @ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;

  editOptionsGridPromocao = null;
  colunasGridPromocao = null;
  promocao = null;
  alturaGrid = null;

  showFilterRow = GridConfig.showFilterRow;
  currentFilter = GridConfig.currentFilter;
  showHeaderFilter = GridConfig.showHeaderFilter;
  columnChooser = GridConfig.columnChooser;
  groupPanel = GridConfig.groupPanel;
  searchPanel = GridConfig.searchPanel;
  exportGrid = GridConfig.exportGrid;

  listaSituacao = listaSituacao;
  listaPoliticaComercial = [
    {Id: 'R', Descricao: 'Residencial'},
    {Id: 'C', Descricao: 'Comercial'},
    {Id: 'F', Descricao: 'Funcionários'}
  ];

  constructor(@Inject(Http) http: Http) {
    this.promocao = new CustomStore({
      insert: function (values) {
        return http.post(`${NTECH_API}/promocao/`, values).toPromise();
      },
      remove: function (key) {
        return http.delete(`${NTECH_API}/promocao/${encodeURIComponent(key.Id)}`).toPromise();
      },
      update: function (key, values) {
        return http.put(`${NTECH_API}/promocao/${encodeURIComponent(key.Id)}`, Object.assign(key, values)).toPromise();
      },
      load: function (loadOptions: any) {
        return http.get(`${NTECH_API}/promocao/`)
            .toPromise()
            .then(response => response.json())
            .catch(error => { throw 'Erro ao carregar dados.'; } );
      }
    });

    this.colunasGridPromocao = [
      {
        dataField: 'Id',
        dataType: 'string',
        caption: 'ID',
        editorOptions: { disabled: true }
      },
      {
        dataField: 'DescricaoPromocao',
        dataType: 'string',
        caption: 'Descrição da Promoção',
        validationRules: [{
          type: 'required',
          message: 'Descrição da Promoção é obrigatório.'
        }]
      },
      {
        dataField: 'SituacaoPromocao',
        caption: 'Situação',
        lookup: {
            dataSource: this.listaSituacao,
            displayExpr: 'Descricao',
            valueExpr: 'Id'
        },
        validationRules: [{
          type: 'required',
          message: 'Situação é obrigatório.'
        }]
      },
      {
        dataField: 'PoliticaComercial',
        caption: 'Política Comercial',
        lookup: {
            dataSource: this.listaPoliticaComercial,
            displayExpr: 'Descricao',
            valueExpr: 'Id'
        },
        validationRules: [{
          type: 'required',
          message: 'Política Comercial é obrigatória.'
        }]
      }
    ];

    this.editOptionsGridPromocao = {
      mode: GridConfig.gridMode, // form
      allowUpdating: true,
      allowAdding: true,
      allowDeleting: true,
      popup: {
        title: 'Promocao',
        showTitle: true
      }
    };
  }

  onCellPrepared = function(e){
    adicionaIconesGrid(e);
  };

  onToolbarPreparing(e) {
    const toolbarItems = e.toolbarOptions.items;

    // Adiciona um novo botao a Toolbar
    toolbarItems.push({
      location: 'after',
      widget: 'dxButton',
      options: {
          icon: 'refresh',
          onClick: this.refreshDataGrid.bind(this)
      }
    });
  }

  refreshDataGrid() {
    this.dataGrid.instance.refresh();
  }

  ngOnInit() {
    this.alturaGrid = calculaAlturaGrid();
  }

}



// WEBPACK FOOTER //
// ./src/app/promocao/promocao.component.ts